import store from '@/store'; // import your Vuex store instance

export class BasePolicy {
  static get user() {
    return store.getters['auth/user'];
  }

  static get userRoles() {
    return store.getters['auth/roles'];
  }

  static get userChannel() {
    return store.getters['auth/channel'];
  }

  static hasAnyRole(roles) {
    if (roles) {
      return this.userRoles.some((role) => roles.includes(role.name));
    }

    return false;
  }

  static hasAnyChannel(channels) {
    if (channels?.length) {
      return channels.some((channel) => this.userChannel === channel);
    }

    return false;
  }

  // For list of models
  static canList() {
    return false;
  }
  // For a single model
  static canView() {
    return false;
  }
  static canCreate() {
    return false;
  }
  static canUpdate() {
    return false;
  }
  static canDelete() {
    return false;
  }
  static canDeleteAny() {
    return false;
  }
}
